import React, { useState, useContext, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useParams } from "react-router";
import { Form, Field } from "react-final-form";
import ButtonSubmit from "../../reuseableComponents/buttons/ButtonSubmit";
import HeaderBox from "../../reuseableComponents/headerBox";
import { UserContext } from "../../reuseableComponents/auth/UserContext";
import { useQuery } from "@apollo/client";

import PublicRoutineBacteriologicalSamplingRequirementTable from "../bacterialSummary/RoutineBacteriologicalSamplingRequirementTable";
import PublicTotalColiformSampleTable from "../bacterialSummary/TotalColiformSampleTable";
//import PublicSourcesTable from "../../public/bacterialSummary/PublicSourcesTable";
import ServiceConnectionTable from "../inventoryReport/ServiceConnectionsTable";
import TreatmentPlantsTable from "../inventoryReport/TreatmentPlantsTable";
import StorageTable from "../inventoryReport/StorageTable";
import PumpingStationTable from "../inventoryReport/PumpingStationTable";
import SourcesTable from "../inventoryReport/SourceTable";
import GroupedSamplingStationTable from "../inventoryReport/GroupedSamplingStationTable";
import DistributionSystemsTable from "../inventoryReport/DistributionSystemsTable";
import SiteVisitHistoryTable from "../inventoryReport/SiteVisitHistoryTable";
import BacteriologicalMonitoringTable from "../monitoringSchedules/BacteriologicalMonitoringTable";
import DisinfectionByProductStage2MonitoringTable from "../monitoringSchedules/DisinfectionByProductStage2MonitoringTable";
import OtherDistributionMonitoringTable from "../monitoringSchedules/OtherDistributionMonitoringTable";
import ChlorineResidualMonitoringTable from "../monitoringSchedules/ChlorineResidualMonitoringTable";
import MonitoringRequirementsByFacilityTable from "../monitoringSchedules/MonitoringRequirementsByFacilityTable";
import OpenComplianceScheduleTable from "../monitoringSchedules/OpenComplianceScheduleTable";

import UserProfileSdwisReportsForm from "../../secure/userProfile/UserProfileSdwisReportsForm";
import { GET_USER_SDWIS_REPORTS } from "../../../queries/archiveQrys/secureQrys/userProfileQrys";

const SystemSummaryReport = ({ customSummary }) => {
  const { user } = useContext(UserContext);
  let { systemId } = useParams();

  let today = new Date();
  let defaultFromDate = new Date(today.getFullYear() - 1, today.getMonth() - 1, 1);
  let lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
  let defaultToDate = new Date(today.getFullYear(), today.getMonth(), lastDayOfMonth);
  let defaultFromString = defaultFromDate.toJSON().split("T")[0];
  let defaultToString = defaultToDate.toJSON().split("T")[0];

  const [fromDate, setFromDate] = useState(defaultFromString);
  const [toDate, setToDate] = useState(defaultToString);

  const [sdwisReports, setSdwisReports] = useState([]);

  const { data } = useQuery(GET_USER_SDWIS_REPORTS, {
    variables: { umdId: user.umdId },
    onCompleted: (data) => {
      setSdwisReports(data.getUserSdwisReportsByUmdId.tables);
    }
  });

  const onSubmit = (values) => {
    setFromDate(values.fromDate);
    setToDate(values.toDate);
  };

  useEffect(() => {
    if (data && data.getUserSdwisReportsByUmdId !== undefined) {
      setSdwisReports(data.getUserSdwisReportsByUmdId.tables);
    }
  }, [data, sdwisReports]);

  return (
    <>
      <hr />
      {customSummary ? (
        <>
          <Row>
            <Col>
              <UserProfileSdwisReportsForm umdId={user.umdId} reportsLoaded={false} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col>
              <HeaderBox id={"gray-primary"} cypressid='mySdwisReport'>
                <h3 style={{ color: "#fff" }}>My SDWIS Selections</h3>
              </HeaderBox>
            </Col>
          </Row>
        </>
      ) : (
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='systemSummaryReport'>
              <h3 style={{ color: "#fff" }}>System Summary Report</h3>
            </HeaderBox>
          </Col>
        </Row>
      )}
      {sdwisReports.find((key) => key.reportId === 0) ? (
        <>
          <Row>
            <Col>
              <h3>Routine Bacteriological Sampling Requirements</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              <PublicRoutineBacteriologicalSamplingRequirementTable systemId={parseInt(systemId)} />
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
      {sdwisReports.find((key) => key.reportId === 1) || !customSummary ? (
        <>
          <Row>
            <Col>
              <h3>Total Coliform Sample History</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form
                onSubmit={onSubmit}
                render={({ handleSubmit, form, submitting, values }) => (
                  <form onSubmit={handleSubmit}>
                    <Row>
                      <Col>
                        <Field
                          name='fromDate'
                          component='input'
                          type='date'
                          className='form-control m-2'
                          initialValue={fromDate}
                        />
                      </Col>
                      <Col>
                        <Field
                          name='toDate'
                          component='input'
                          type='date'
                          className='form-control m-2'
                          initialValue={toDate}
                        />
                      </Col>
                      <Col>
                        <ButtonSubmit id='ddw-primary' onClick={() => onSubmit(values)} />
                      </Col>
                    </Row>
                  </form>
                )}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <PublicTotalColiformSampleTable systemId={parseInt(systemId)} fromDate={fromDate} toDate={toDate} />
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
      {sdwisReports.find((key) => key.reportId === 11) || !customSummary ? (
        <>
          <Row>
            <Col>
              <h3>Service Connections</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              <ServiceConnectionTable systemId={parseInt(systemId)} />
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
      {sdwisReports.find((key) => key.reportId === 23) || !customSummary ? (
        <>
          <Row>
            <Col>
              <h3>Treatment Plants</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              <TreatmentPlantsTable systemId={parseInt(systemId)} />
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
      {sdwisReports.find((key) => key.reportId === 24) || !customSummary ? (
        <>
          <Row>
            <Col>
              <h3>Storage</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              <StorageTable systemId={parseInt(systemId)} />
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
      {sdwisReports.find((key) => key.reportId === 25) || !customSummary ? (
        <>
          <Row>
            <Col>
              <h3>Pumping Stations</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              <PumpingStationTable systemId={parseInt(systemId)} />
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
      {sdwisReports.find((key) => key.reportId === 2) || !customSummary ? (
        <>
          <Row>
            <Col>
              <h3>Sources</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              <SourcesTable systemId={parseInt(systemId)} />
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
      {sdwisReports.find((key) => key.reportId === 8) || !customSummary ? (
        <>
          <Row>
            <Col>
              <h3>Grouped Source Sampling Stations</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              <GroupedSamplingStationTable systemId={parseInt(systemId)} />
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
      {sdwisReports.find((key) => key.reportId === 26) || !customSummary ? (
        <>
          <Row>
            <Col>
              <h3>Distribution System</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              <DistributionSystemsTable systemId={parseInt(systemId)} />
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
      {sdwisReports.find((key) => key.reportId === 27) || !customSummary ? (
        <>
          <Row>
            <Col>
              <h3>Site Visit History</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              <SiteVisitHistoryTable systemId={parseInt(systemId)} />
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
      {sdwisReports.find((key) => key.reportId === 28) || !customSummary ? (
        <>
          <Row>
            <Col>
              <h3>File Upload History</h3>
            </Col>
          </Row>
          <Row>
            <Col>{/* <FileUploadHistoryTable systemId={parseInt(systemId)} /> */}</Col>
          </Row>
        </>
      ) : (
        ""
      )}
      {sdwisReports.find((key) => key.reportId === 3) || !customSummary ? (
        <>
          <Row>
            <Col>
              <h3>Bacteriological Monitoring</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              <BacteriologicalMonitoringTable systemId={parseInt(systemId)} />
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
      {sdwisReports.find((key) => key.reportId === 4) || !customSummary ? (
        <>
          <Row>
            <Col>
              <h3>Disinfection ByProduct Stage 2 Monitoring</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              <DisinfectionByProductStage2MonitoringTable systemId={parseInt(systemId)} />
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
      {sdwisReports.find((key) => key.reportId === 5) || !customSummary ? (
        <>
          <Row>
            <Col>
              <h3>Other Distribution Monitoring</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              <OtherDistributionMonitoringTable systemId={parseInt(systemId)} />
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
      {sdwisReports.find((key) => key.reportId === 6) || !customSummary ? (
        <>
          <Row>
            <Col>
              <h3>Chlorine Residual Monitoring</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              <ChlorineResidualMonitoringTable systemId={parseInt(systemId)} />
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
      {sdwisReports.find((key) => key.reportId === 7) || !customSummary ? (
        <>
          <Row>
            <Col>
              <h3>Monitoring Requirements By Facility</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              <MonitoringRequirementsByFacilityTable systemId={parseInt(systemId)} />
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
      {sdwisReports.find((key) => key.reportId === 9) || !customSummary ? (
        <>
          <Row>
            <Col>
              <h3>Open Compliance Schedules</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              <OpenComplianceScheduleTable systemId={parseInt(systemId)} />
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default SystemSummaryReport;
